import React, { useRef } from "react";

type UseSingleAndDoubleRowClickProps<T,> = {
    onClick: (row: T, event: React.MouseEvent) => void,
    onDoubleClick: (row: T, event: React.MouseEvent) => void,
}

const useSingleAndDoubleRowClick = <T,>({ onClick, onDoubleClick }: UseSingleAndDoubleRowClickProps<T>) => {

	const timePassed= useRef(0);

	return (row: T, e: React.MouseEvent) => {
		if (e.detail === 1) {
			setTimeout(() => {
				if (Date.now() - timePassed.current >= 250) {
					onClick(row, e);
				}
			}, 250)
		}

		if (e.detail === 2) {
			timePassed.current = Date.now();
			onDoubleClick(row, e);
		}
	}
}

export default useSingleAndDoubleRowClick;
